import React from 'react';

const UseOfTerms = () => {
    return (
        <div className="min-h-screen flex flex-col justify-between bg-white text-gray-800">
            {/* Header */}
            <header className="bg-gray-100 border-b">
                <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
                    <h1 className="text-lg font-semibold">ESTI</h1>
                    <a href="/" className="text-blue-600 hover:underline text-sm">← Басты бетке оралу</a>
                </div>
            </header>

            {/* Main Content */}
            <main className="flex-grow max-w-4xl mx-auto p-6">
                <h1 className="text-3xl font-bold mb-6">Пайдалану шарттары</h1>

                <p className="mb-4">
                    Бұл пайдалану шарттары <a href="https://esti.kz" className="text-blue-600 underline">https://esti.kz</a> веб-сайтының
                    барлық пайдаланушылары үшін міндетті болып табылады. Веб-сайтты қолдана отырып, сіз осы шарттарға келісесіз.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">1. Веб-сайтты пайдалану</h2>
                <p className="mb-4">
                    Сіз осы веб-сайтты тек заңды мақсаттарда және біздің қызметтерімізді қолдануға арналған жағдайларда ғана пайдалана аласыз.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">2. Пайдаланушы жауапкершілігі</h2>
                <p className="mb-4">
                    Сіз сайтқа өзіңіз қосатын барлық ақпараттың дұрыстығын қамтамасыз етесіз және біздің саясымызға сәйкес болуына жауаптысыз.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">3. Қызметтерді өзгерту</h2>
                <p className="mb-4">
                    Біз кез келген уақытта веб-сайтты немесе қызметтерімізді жаңарту, өзгерту немесе тоқтату құқығына ие боламыз.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">4. Құқықтардың сақталуы</h2>
                <p className="mb-4">
                    Біздің веб-сайтта орналастырылған барлық мазмұн мен ақпарат авторлық құқықпен қорғалған.
                    <br />
                    <strong>Аудио файлдар:</strong> Барлық аудио файлдар заңды түрде авторлық құқықпен қорғалады. Оларды рұқсатсыз бөліктеп немесе толық пайдалану, көшірмелеу, тарату немесе коммерциялық мақсатта қолдану қатаң тыйым салынады. Бұл шарттарды бұзу заңды жауапкершілікке әкеп соғады.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">5. Пайдалану шарттарының өзгеруі</h2>
                <p className="mb-4">
                    Біз осы шарттарды кез келген уақытта өзгерту құқығын өзімізде қалдырамыз. Өзгерістер күшіне енгеннен кейін веб-сайтты пайдалану осы жаңа шарттарға сәйкес болады.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">6. Байланыс</h2>
                <p className="mb-4">
                    Пайдалану шарттарына қатысты сұрақтарыңыз болса, бізге <a href="mailto:musaaldanazarov@gmail.com" className="text-blue-600 underline">musaaldanazarov@gmail.com</a> поштасы арқылы хабарласыңыз.
                </p>
            </main>

            {/* Footer */}
            <footer className="bg-gray-100 border-t mt-10">
                <div className="max-w-6xl mx-auto px-4 py-4 text-sm text-center text-gray-500">
                    © {new Date().getFullYear()} ESTI. Барлық құқықтар қорғалған.
                </div>
            </footer>
        </div>
    );
};

export default UseOfTerms;